import Store from 'lightningjs-redux';
import { getCurrentRoute } from '../../../../../logic/routing/routing.selectors';

const mapControllers = instance => [
  {
    selector: getCurrentRoute,
    callback: () => {
      instance.updateLogo();
    },
  },
];

export default Store.control(mapControllers);
